import { useState } from "react";
import type { GameCommand, PlayerProjection } from "@saboteur/contracts";

type HandCard = PlayerProjection["self"]["hand"][number];
export function useTurnInteraction(projection: PlayerProjection) {
  const [selectedCardId, setSelectedCardId] = useState<string>();
  const [rotation, setRotation] = useState<0 | 180>(0);
  const [pendingCommand, setPendingCommand] = useState<GameCommand>();
  const [version, setVersion] = useState(projection.public.version);
  if (version !== projection.public.version) {
    setVersion(projection.public.version);
    setPendingCommand(undefined);
    if (!projection.self.hand.some((card) => card.cardId === selectedCardId))
      setSelectedCardId(undefined);
  }
  const selectedCard = projection.self.hand.find((card) => card.cardId === selectedCardId);
  return {
    selectedCard,
    rotation,
    setRotation,
    pendingCommand,
    setPendingCommand,
    setSelectedCard: (card: HandCard | undefined) => setSelectedCardId(card?.cardId),
  };
}
